import app from "@/main";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import _ from "lodash-es";
import Path from "@/lib/common/path";
import Config from "@/config/config";
import Auth from "@/lib/common/auth";
import { Crypto } from "@/lib/model/account/utils";

const handles = new Map<number, Function>();
const axiosInstance = axios.create();
const axiosInstanceWithoutAutoResolve = axios.create();

const requestMiddleware: any = (config: AxiosRequestConfig) => {
  const data = config.data ? config.data : {};
  data["companyId"] = Auth.companyId;
  // 等保需要对登录登接口进行加密
  if (config.data?.needAesEncrypt) {
    config.data = Crypto.encryptData(config.data);
  } else {
    config.data = data;
  }
  const headers = config.headers ? config.headers : {};
  headers["AUTHORIZATION"] = "Bearer " + Auth.token;
  return config;
};

handles.set(302, (resp: AxiosResponse) => {
  location.href = resp.data.url;
  return Promise.reject(resp);
});

axiosInstance.interceptors.request.use(requestMiddleware, err => {
  return Promise.reject(err);
});

axiosInstance.interceptors.response.use(
  (resp: AxiosResponse) => {
    const data = resp.data;
    if (_.isEmpty(data)) {
      resp.data = {
        code: -500,
        message: "网络错误，请稍后再试"
      };
      return Promise.reject(resp);
    }
    const code = parseInt(data["code"]);
    if (handles.get(code)) {
      const f = handles.get(code);
      if (f) {
        return f(resp);
      }
    }
    //阅卷页特判 406时 不弹错误信息
    try {
      const params = JSON.parse(resp.config.data);
      if (code === 406 && params?.ignore406) {
        return resp;
      }
    } catch (error) {
      console.log(error);
    }

    if (code !== 0) {
      app.$message.error(resp.data.message);
      return Promise.reject(resp);
    }
    return resp;
  },
  err => {
    return Promise.reject(err);
  }
);

axiosInstanceWithoutAutoResolve.interceptors.request.use(
  requestMiddleware,
  err => {
    return Promise.reject(err);
  }
);

axiosInstanceWithoutAutoResolve.interceptors.response.use(
  (resp: AxiosResponse) => {
    const data = resp.data;
    if (_.isEmpty(data)) {
      resp.data = {
        code: -500,
        message: "网络错误，请稍后再试"
      };
      return Promise.reject(resp);
    }
    const code = parseInt(data["code"]);
    if (code != 0) {
      return Promise.reject(resp);
    }
    return resp;
  },
  err => {
    return Promise.reject(err);
  }
);

export class UploadFile {
  name = "";
  status = "";
  size = 0;
  percentage = 0;
  uid = 0;
  raw!: File;
}

class AccountRequest {
  protected url(pathname: string): string {
    return pathname.startsWith("http://") || pathname.startsWith("https://")
      ? pathname
      : Path.join(Config.accountLoginUrl, pathname);
  }

  public uploadUrl(pathname: string): string {
    return pathname.startsWith("http://") || pathname.startsWith("https://")
      ? pathname
      : Path.join(Config.accountLoginUrl, pathname);
  }
  post(pathname: string, params?: any, autoResolve = true) {
    const url = this.url(pathname);
    const instance = autoResolve
      ? axiosInstance
      : axiosInstanceWithoutAutoResolve;
    return instance.post(url, params);
  }
  upload(pathname: string, uploadFile: UploadFile) {
    const form = new FormData();
    const con: any = {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent: ProgressEvent) => {
        if (progressEvent.lengthComputable) {
          uploadFile.percentage =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        }
      }
    };
    form.append("file", uploadFile.raw);
    let url = this.url(pathname);
    url = Path.setParam(url, "companyId", Auth.companyId);
    return axiosInstance.post(url, form, con);
  }
}

export default new AccountRequest();
